
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-select',
    label: '可參與身分別',
    model: 'role',
    required: true,
    values() {
      return [
        { 'id': 0, 'name': "訪客" },
        { "id": 1, "name": "媽媽" },
        { "id": 2, "name": "員工" }
      ];
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: '課程類型',
    model: 'course_type_id',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/course-type-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: '課程地點',
    model: 'course_place_id',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/course-place-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '課程名稱',
    model: 'name',
    placeholder: '課程名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: '關聯課程',
    hint: '適用於上下午場不可重複報名使用',
    model: 'course_id',
    required: false,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/course-list?id=' + this.$route.params.id, false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "課程介紹",
    model: "detail",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "備註",
    model: "note",
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '老師名稱',
    model: 'teacher',
    placeholder: '老師名稱',
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "課程費用",
    model: "fee",
    hint: "免費請填 0",
    placeholder: "課程費用",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "人數上限",
    model: "limit_up",
    placeholder: "人數上限",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "人數下限",
    model: "limit_down",
    placeholder: "人數下限",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-dateTimePicker",
    label: "活動開始時間",
    model: "start_at",
    placeholder: "請選擇日期",
    required: true,
    hideClockIcon: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-dateTimePicker",
    label: "活動結束時間",
    model: "end_at",
    placeholder: "請選擇日期",
    required: true,
    hideClockIcon: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "報名者時間範圍(天)",
    model: "limit_up",
    placeholder: "報名者時間範圍(天)",
    hint: '報名者者報名天數上限、0 則不限制',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "報名者報名次數上限",
    model: "limit_up",
    placeholder: "報名者次數限制",
    hint: '報名者「報名者時間範圍」內報名次數上限、0 則不限制',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '報名網址',
    hint: '雙親教室外部廠商用 (請加上 http:// 或者 https://)',
    model: 'extra_url',
    placeholder: '報名網址',
  },
];

export default fields;
